import { AgentsFactoryActionTypes } from './agentsFactory.types';

const signupRequest = () => ({ type: AgentsFactoryActionTypes.AGENTS_FACTORY_SIGNUP_REQUEST });
const signupSuccess = agentAuth => ({ type: AgentsFactoryActionTypes.AGENTS_FACTORY_SIGNUP_SUCCESS, payload: agentAuth });
const signupFailure = error => ({ type: AgentsFactoryActionTypes.AGENTS_FACTORY_SIGNUP_FAILURE, payload: error });

const actions = {
  signup: {
    request: signupRequest,
    success: signupSuccess,
    failure: signupFailure,
  },
};

export default actions;
